export default "__VITE_ASSET__DWfV1oMw__"